import { createSlice } from '@reduxjs/toolkit';
import { todayFormatted } from 'helpers.js';

const initialState = {
  caricamentoInCorso: true,
  bi: [],
  calendario: todayFormatted(),
  contestazioni: [],
  clienti: [],
  portafoglio: [],
  vendite: [],
};

const biSlice = createSlice({
  name: 'bi',
  initialState,
  reducers: {
    caricamento(state, action) {
      state.caricamentoInCorso = Boolean(action.payload);
    },
    aggiornaBi(state, action) {
      state.bi = action.payload;
    },
    aggiornaCalendario(state, action) {
      state.calendario = action.payload;
    },
    aggiornaContestazioni(state, action) {
      state.contestazioni = action.payload;
    },
    aggiornaClienti(state, action) {
      state.clienti = action.payload;
    },
    aggiornaPortafoglio(state, action) {
      state.portafoglio = action.payload;
    },
    aggiornaVendite(state, action) {
      state.vendite = action.payload;
    },
  },
});

export const { caricamento, aggiornaBi, aggiornaCalendario, aggiornaContestazioni, aggiornaClienti, aggiornaPortafoglio, aggiornaVendite } = biSlice.actions;
const biReducer = biSlice.reducer;

export default biReducer;
